module.exports = __webpack_public_path__ + "static/media/usArt.74255d2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/usArt.png
// module id = 296
// module chunks = 0